import { i18n, type Locale, type Messages } from '@lingui/core';
import { messages as enMessages } from '../../locale/en/messages';
import { messages as fiMessages } from '../../locale/fi/messages';
import { messages as nbMessages } from '../../locale/nb/messages';

export function loadI18nStatic() {
    i18n.load({ en: enMessages, fi: fiMessages, nb: nbMessages });
}

export function activateI18n(locale: Locale) {
    i18n.activate(locale);
}

export function loadAndActivateI18n(locale: Locale) {
    const messages = getMessages(locale, enMessages, nbMessages, fiMessages);
    i18n.load(locale, messages);
    i18n.activate(locale);
}

export function getMessages(
    locale: Locale,
    enMsg: Messages,
    nbMsg: Messages,
    fiMsg: Messages,
) {
    switch (locale) {
        case 'nb':
            return nbMsg;
        case 'fi':
            return fiMsg;
        default:
            return enMsg;
    }
}
